enum SetNewPasswordFields {
  PASSWORD = 'password',
  CONFIRMED_PASSWORD = 'confirmedPassword',
}

export default SetNewPasswordFields;
